export enum UserRole {
    gamificationAdmin = 'Gamification Admin',
    customer = 'Self-Service Customer',
    member = 'Topcoder User',
    tcaAdmin = 'TCA Admin',
    administrator = 'administrator',
    connectManager = 'Connect Manager',
    paymentAdmin = 'Payment Admin',
    paymentViewer = 'Payment Viewer',
    paymentProviderAdmin = 'PaymentProvider Admin',
    paymentProviderViewer = 'PaymentProvider Viewer',
    projectManager = 'Project Manager',
    taxFormAdmin = 'TaxForm Admin',
    taxFormViewer = 'TaxForm Viewer'
}
